<script setup lang="ts">
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
</script>

<template>
  <Header></Header>
  <main>
    <router-view v-slot="{ Component }">
      <transition>
        <component :is="Component" />
      </transition>
    </router-view>
  </main>
  <div
    data-aos="zoom-in-up"
    data-aos-delay="200"
    data-aos-duration="1000"
    data-aos-once="true"
  >
    <Footer></Footer>
  </div>
</template>

<style>
.container {
  max-width: 100%;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-left: 240px;
  padding-right: 240px;
}

@media (max-width: 1536px) {
  .container {
    margin-left: auto;
    margin-right: auto;
    padding-left: 180px;
    padding-right: 180px;
  }
}
@media (max-width: 1280px) {
  .container {
    margin-left: auto;
    margin-right: auto;
    padding-left: 120px;
    padding-right: 120px;
  }
}

@media (max-width: 1024px) {
  .container {
    margin-left: auto;
    margin-right: auto;
    padding-left: 60px;
    padding-right: 60px;
  }
}
@media (max-width: 640px) {
  .container {
    margin-left: auto;
    margin-right: auto;
    padding-left: 20px;
    padding-right: 20px;
  }
}
</style>
